import React from "react";
import { MenuList } from "../helpers/MenuList";
import MenuItem from "../components/MenuItem";
import "../styles/Services.css";
import menu_back from "../assets/menu_back.jpg"
function Services() {

  return (
  
  
    <div className="menu"  style={{
      backgroundImage: `url(${menu_back})`
    }}>
      <h1 className="menuTitle">Choose Your Art</h1>
     <div className="menuList" >
        {MenuList.map((menuItem, key) => {
          return (
            <MenuItem
              key={key}
              image={menuItem.image}
              name={menuItem.name}
              price={menuItem.price}
              
            />
          );
        })}
      </div>
    
    </div>

  );
}

export default Services;
